<template>
  <v-row justify="center">
    <v-dialog v-model="open" :max-width="mWidth">
      <v-card>
        <v-card-title class="headline">
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text>
          <slot></slot>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="$emit('cancel')" v-if="!hideCancel">
            {{ text.buttons.cancel }}
          </v-btn>

          <v-btn color="primary" text @click="$emit('confirm')" v-if="!hideConfirm">
            {{ text.buttons.confirm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { translations } from '@/lang/translations';

export default {
  name: 'DialogContainer',
  props: ['open', 'hideCancel', 'hideConfirm', 'title', 'content', 'width'],
  data() {
    return {
      text: translations.pl,
    };
  },
  computed: {
    dialogTitle() {
      return this.title ?? this.text.dialogTitle;
    },
    mWidth() {
      return this.width ?? 290;
    },
  },
};
</script>

<style scoped>
</style>
